import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { INoteButton } from "../../app/models/toolbar";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  button: INoteButton;
}

const FileNoteButton: React.FC<IParams> = ({ button }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const { openFileNoteModal, currentFileHasNote } = rootStore.playerStore;

  return (
    <>
      <Button
        id="btnFileNote"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          currentFileHasNote
            ? `${theme!.toolbarActiveIconColor}`
            : `${theme!.toolbarIconColor}`
        )}
        color=""
        onClick={openFileNoteModal}
        style={{ position: "relative" }}
      >
        <i
          className={classNames(
            "far fa-sticky-note iconToolbarButton"
            // currentFileHasNote ? "text-red" : ""
          )}
        ></i>
        <h6 className="textToolbarButton mb-0">
          {t("toolbar_notes_file_button")}
        </h6>
      </Button>
    </>
  );
};

export default observer(FileNoteButton);
